import { Form } from '@unform/web';
import styled from 'styled-components';

export const Container = styled(Form)`
  display: flex;
  flex-direction: column;

  .modal-container {
    min-width: 40rem;
  }

  label {
    margin-left: 0.5rem;
  }

  .input-file .label-input {
    margin-left: 0;
  }

  .text-area,
  .input-file {
    margin-top: 1rem;
  }

  .group-items {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    width: 100%;
  }

  .group-items + .group-items,
  .group-items + .input-with-label,
  .input-with-label + .group-items {
    margin-top: 1rem;
  }

  .group-items .input-with-label + .input-with-label,
  .group-items .select-with-label + .select-with-label {
    margin-top: 0;
  }

  .group-items .input-with-label,
  .group-items .select-with-label {
    width: 100%;
  }

  .group-items.two-columns .input-with-label:first-child {
    flex: 1.5;
  }

  .group-items.two-columns .input-with-label:last-child {
    flex: 0.8;
  }

  @media (max-width: 470px) {
    .group-items.inputs-radio {
      flex-direction: column;
    }
  }
`;
